<template>
  <div class="footer">
    <!-- <img src="../assets/footer.png" alt="" style="width: 100%;display: inline-block;"> -->
    <div class="bx">
      <div class="service">
        <div class="left">
          <p class="title1111">鸿之博 · 云智选</p>

          <div class="links">
            <ul>
              <li class="t">关于我们</li>
              <li><a href="#">公司动态</a></li>
              <li><a href="#">招商加盟</a></li>
              <li><a href="https://yunzhixuanpro.fw366.cn/admin" target="_blank">后台入口</a></li>
            </ul>
            <ul>
              <li class="t">热门功能</li>
              <li><a @click="jump('/ai',true)">智能AI填报</a></li>
              <li><a @click="jump('/artificial',true)">人工填报</a></li>
              <li><a @click="jump('/form',true)">志愿审核</a></li>
              <li><a @click="jump('/futureEasy',true)">前程无忧</a></li>
            </ul>
            <ul>
              <li class="t">友情链接</li>
              <li><a href="http://www.moe.gov.cn/" target="_blank">中华人民共和国教育部</a></li>
              <li><a href="http://www.heao.com.cn/main/html/" target="_blank">河南招生考试信息网</a></li>
              <li><a href="http://jyt.henan.gov.cn/" target="_blank">河南省教育厅</a></li>
            </ul>
            <ul>
              <li class="t">各省考试院</li>
              <ul class="flex">
                <li class="url" @click="hrefClick(item)" v-for="(item,index) in data" :key="item.id">
                  {{item.title}}
                </li>
              </ul>
            </ul>
          </div>
        </div>
        <div class="right">
          <div class="app">
            <a href="">
              <img src="https://yunzhixuanpro.fw366.cn/static/img/new/phone.png" alt="">
              <p>手机APP</p>
            </a>
            <span class="qrcode">
              <img src="../assets/app.png" alt="">
            </span>
          </div>
          <div class="mini">
            <a href="">
              <img src="https://yunzhixuanpro.fw366.cn/static/img/new/mini.png" alt="">
              <p>小程序</p>
            </a>
            <span class="qrcode">
              <img src="../assets/xcx.jpg" alt="">
            </span>
          </div>
          <div class="public">
            <a href="">
              <img src="https://yunzhixuanpro.fw366.cn/static/img/new/wechat.png
" alt="">
              <p>微信公众号</p>
            </a>
            <span class="qrcode">
              <img src="https://yunzhixuanpro.fw366.cn/static/img/new/gzh.png" alt="">
            </span>
          </div>
        </div>
      </div>
      <div class="sites">
        <span class="s">公司地址：河南省郑州市金水区花园路农广花园704</span>
        <span class="s">加盟热线：0371-88176175 / 15138687288</span>
        <span class="s">邮箱地址：hnhzbjykj@163.com</span>
        <span class="s">备案号：豫ICP备19046549号-1</span>
        <div style="margin-right: 3%;display: inline-block;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010502005607"><img
              src="" style="float:left;" />
            <p style="color: #999999;">
              <img src="../assets/icon.png" alt="" style="width: 20px;height: 20px;vertical-align: middle;">
              豫公网安备
              41010502005607号
            </p>
          </a>
        </div>
        <span>技术支持：鸿之博教育科技有限公司</span>

      </div>


    </div>
  </div>
</template>

<script>
  import {
    jump
  }
  from '../../static/function.js'
  export default {
    data() {
      return {
        data: []
      }
    },
    props: {
      data: {
        required: true,
        default: []
      }
    },
    mounted() {

    },
    methods: {
      hrefClick(item) {
        // let url = 'https://' + item.url
        // console.log(url)
        window.open(item.url)
      }
    }
  }
</script>

<style scoped lang="scss">
  .footer {
    // font-size: 0;
    width: 100%;
    // height: 255px;
  }

  * {
    padding: 0;
    margin: 0;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  a:hover,
  a:focus {
    text-decoration: none;
  }

  /* 头部样式 */
  .h-one {
    width: 75%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .bx {
    width: 90%;
    margin: 0 auto;
  }

  .h-one .left {
    width: 73%;
    display: flex;
    align-items: center;
  }

  .url {
    width: 120px;
    margin-right: 10px;
    color: #999999;
    cursor: pointer;
    text-align: left;
  }

  .logo {
    /*width: 18.5%;*/
    width: 260px;
    /*width: 38.5%;*/
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo-tu {
    width: 66px;
    height: 66px;
  }

  .logo-tu img {
    vertical-align: middle;
  }

  .logo .logo-p {
    padding-left: 5px;
    width: 180px;
    font-size: 20px;
    font-weight: 400;
    color: #236DB8;
  }

  .search {
    width: 266px;
    height: 35px;
    margin-left: 70px;
    display: inline-block;
  }

  .search .el-input .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    background-color: #F2F2F2 !important;
  }

  .el-input__icon {
    color: #2C57A7 !important;
    line-height: 30px !important;
  }

  .login {
    width: 200px;
    display: flex;
    align-items: center;
  }

  .log-left {
    width: 72px;
  }

  .location {
    display: flex;
  }

  .changecity {
    margin-left: 4px;
    font-size: 12px;
    color: #2C57A7;
    line-height: 22px;
  }

  .log-right {
    display: flex;
    position: relative;
  }

  .log-right a {
    min-width: 30px;
    font-size: 12px;
    color: #2C57A7;
    line-height: 40px;
    margin-left: 5px;
  }

  .log-right .dt_img {
    width: 40px;
    height: 40px;
    border-radius: 78px;
    background-color: palegreen;
  }

  /* 二级样式 */
  .log-right .forecast {
    position: absolute;
    display: none;
    top: 40px;
    right: 0px;
    background-color: #fff;
    box-shadow: 0 1px 6px 0 rgba(32, 33, 36, .28);
    z-index: 222;
  }

  .log-right .forecast li a {
    background-color: #fff;
    display: block;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #999;
    font-size: 16px;
    margin-left: 0;
  }

  .log-right .forecast li a:after {
    content: '';
    position: absolute;
    width: 90%;
    height: 1px;
    bottom: 38px;
    left: 5%;
    background: rgba(0, 0, 0, 0.1);
  }

  .log-right .forecast li a:hover,
  .log-right .forecast .version li a:hover {
    color: #236DB8;
    background-color: #F2F2F2;
  }

  .log-right:hover .forecast {
    display: block;
  }

  /* 测试的二级样式 */
  .test_class .forecast {
    width: 110px;
    position: absolute;
    display: none;
    /*top: 5%;*/
    right: 25.3%;
    background-color: #fff;
    box-shadow: 0 1px 6px 0 rgba(32, 33, 36, .28);
    z-index: 222;
  }

  .test_class .forecast li a {
    background-color: #fff;
    display: block;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #999;
    font-size: 16px;
    margin-left: 0;
  }

  .test_class .forecast li a:after {
    content: '';
    position: absolute;
    width: 90%;
    height: 1px;
    bottom: 38px;
    left: 5%;
    background: rgba(0, 0, 0, 0.1);
  }

  .test_class .forecast li a:hover,
  .test_class .forecast .version li a:hover {
    color: #236DB8;
    background-color: #F2F2F2;
  }

  .test_class:hover .forecast {
    display: block;
  }


  .h-two {
    height: 52px;
    background-color: #5085e6;
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .nav {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }

  .nav ul li {
    float: left;
    margin: 0 3.8%;
    color: #ffffff;
  }

  @media (min-width: 1600px) and (max-width: 1800px) {
    .nav ul li {
      margin: 3.8%;
    }
  }

  .nav ul li:hover a {
    color: #ffeb0e;
    /*border-bottom: 2px solid #ffeb0e;*/
    /* padding-bottom:5px;*/
  }

  .nav ul li a {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
  }

  /* 右侧广告部分 */
  .ad {
    width: 300px;
    position: absolute;
    top: 60px;
  }

  .ad .ad_one {
    width: 281px;
    height: 61px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    display: flex;
    margin-bottom: 9px;
  }

  .ad .ad_one .ad_msg a:hover,
  .ad .ad_one .ad_msg a:hover p {
    color: #236db8;
  }

  .ad .ad_one img {
    width: 53px;
    height: 53px;
    margin-left: 8px;
    margin-top: 4px;
  }

  .ad .ad_one .ad_msg {
    width: 180px;
    height: 45px;
    margin-left: 5px;
  }

  .ad .ad_one .ad_msg a {
    color: #999;
  }

  .ad .ad_one .ad_msg p {
    margin-top: 5px;
    /*margin-bottom: 8px;*/
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .ad .ad_one .ad_msg a span {
    font-size: 12px;
  }

  .ad_one_sp1 {
    font-size: 12px;
  }

  .ad_one_sp2 {
    font-size: 12px;
  }

  .ad .ad_one .ad_msg .ad_one_sp2 {
    margin-left: 10px;
  }

  .ad .ad_two {
    margin-top: 25px;
    overflow: hidden;
  }

  .ad .ad_two ul li {
    float: left;
    width: 88px;
    height: 60px;
    border-radius: 8px;
    background-color: #eee;
    margin-right: 10px;
    margin-bottom: 19px;
  }

  a:hover {
    cursor: pointer;
  }

  .ad .ad_three {
    position: relative;
    width: 185px;
    height: 139px;
    background-color: #eee;
    margin: 0 auto;

  }

  .ad .ad_three .intr {
    position: absolute;
    bottom: 0;
    width: 185px;
    height: 31px;
    background-color: #000;
    opacity: 0.5;
  }

  .ad .ad_three .intr span {
    font-size: 14px;
    color: #fff;
  }

  /* 底部样式 */
  .footer {
    width: 100%;
    padding-bottom: 30px;
    // height: 240px;
    background-color: #3C3C3C;
  }

  .footer .service {
    width: 100%;
    // height: 175px;
    display: flex;
  }

  .footer .service .left {
    /*width: 500px;*/
    width: 73%;
  }

  .footer .service .right {
    /*width: 270px;*/
    width: 22.8%;
    height: 67px;
    /*margin-left: 355px;*/
    margin-left: 29.8%;
    margin-top: 111px;
  }

  .service .left .title1111 {
    /*width: 129px;*/
    /*height: 20px;*/
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 25px;
    text-align: left;
  }

  .service .left .links {
    display: -webkit-box;
    margin-top: 25px;
  }

  .service .left .links ul {
    /*margin-right: 40px;*/
    margin-right: 5%;
  }

  .service .left .links ul li {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .service .left .links .t {
    color: #fff;
    margin-bottom: 14px;
  }

  .service .left .links ul li a {
    color: #999999;
  }

  .service .right {
    display: flex;
    justify-content: space-between;
  }

  .service .right .app {
    /*width: 47px;*/
    /*width: 17.4%;*/
    height: 100%;
    position: relative;
  }

  .service .right .mini {
    position: relative;
    /*width: 45px;*/
    /*width: 16.6%;*/
    height: 100%;
    text-align: center;
  }

  a img {
    height: 50px;
  }

  .service .right .public {
    position: relative;
    /*width: 60px;*/
    /*width: 22.2%;*/
    height: 100%;
    text-align: center;
  }

  .service .right img {
    width: 100%;
  }

  .service .right .public img {
    /*width: 50px;*/
    width: 84%;
  }

  .service .right p {
    /*width: 48px;*/
    width: 100%;
    height: 11px;
    font-size: 12px;
    color: #999999;
    margin-top: 8px;
  }

  // .service .right .mini p {
  //   width: 42px;
  //   margin-top: 10px;
  // }

  .service .right .public p {
    width: 60px;
    margin-top: 6px;
  }

  .service .right .app span img,
  .service .right .mini span img,
  .service .right .public span img {
    position: absolute;
    top: -106px;
    left: -26px;
    width: 100px;
    height: 100px;
    display: none;
  }

  .service .right .app:hover .qrcode img,
  .service .right .mini:hover .qrcode img,
  .service .right .public:hover .qrcode img {
    display: block;
  }

  .footer .sites {
    margin-top: 35px;
    font-size: 12px;
    color: #999999;
    text-align: left;
  }

  .footer .sites span {
    width: 273px;
    height: 11px;
  }

  .footer .sites .s {
    /*margin-right: 92px;*/
    margin-right: 1%;
  }

  @media (min-width: 1680px) {
    .footer .sites .s {
      /*margin-right: 92px;*/
      margin-right: 3%;
    }
  }

  /* 标题样式----------公共样式 */
  .in_title11 {
    height: 40px;
  }

  .in_title11 .before_title11 {
    width: 5px;
    height: 26px;
    background-color: #236db8;
    margin: 9px 10px 0 0;
    float: left;
  }

  .in_title11 .title11_name {
    display: inline-block;
    width: 200px;
    height: 40px;
    line-height: 40px;
    color: #333;
    font-size: 26px;
  }

  /* 选中样式 */
  /*.active{*/
  /*    !*background-color: palegreen;*!*/
  /*    color: #236db8;*/
  /*}*/
  // main {
  //   width: 1280px;
  //   margin: 0 auto;
  // }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue